import React, {useContext, useEffect, useState} from 'react';
import {withNotificationConfigListContext} from './context/notificationConfigList';
import {withNavigation} from '../../navigation/navigation';
import {Box, Breadcrumbs, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useNotificationConfigList} from './hooks/notificationConfigList';
import NotificationConfigItem from './NotificationConfigItem';
import {useNotificationConfigUpdate} from './hooks/notificationConfigUpdate';
import NotificationConfigItemPlaceholder from './NotificationConfigItemPlaceholder';
import {useDarkMode} from '../../darkMode/hook/useDarkMode';

const NotificationConfigList = ({setShowNav}) => {
  const navigate = useNavigate();
  useEffect(() => setShowNav(false), []);
  const {notificationConfigs, loading} = useNotificationConfigList();
  const {update} = useNotificationConfigUpdate();
  const [openedItemId, setOpenedItemId] = useState();

  const handleOpen = id => (event, isExpanded) => {
    setOpenedItemId(isExpanded ? id : false);
  };

  const {mode} = useDarkMode();

  return (
    <Box
      style={{
        alignSelf: 'flex-start',
        width: '100%',
        backgroundColor: mode.settings.backgroundColor,
      }}>
      <Box
        style={{
          backgroundColor: mode.settings.cardBackgroundColor,
          maxWidth: '100%',
          padding: 15,
        }}
        id="notification-config-list">
        <Box sx={{marginBottom : '15px'}}>
            <Typography variant={'subtitle10'} color={mode.settings.textColor3} >
                Paramètres de notifications
            </Typography>
        </Box>

        <Stack pl={5}>
          {!loading &&
            notificationConfigs.map(item => (
              <NotificationConfigItem
                {...item}
                key={item.id}
                onChange={update}
                openedId={openedItemId}
                handleOpened={handleOpen}
              />
            ))}
          {loading &&
            Array(5)
              .fill(1)
              .map((_, index) => (
                <NotificationConfigItemPlaceholder key={index} />
              ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default withNavigation(
  withNotificationConfigListContext(NotificationConfigList),
);
